import _cloneDeep from 'lodash/cloneDeep';

export const campaignNormalizeData = campaign => {
  const clonedCampaign = _cloneDeep(campaign);

  if (clonedCampaign?.rules?.length > 0) {
    const ruleNameToFind = 'Push Notification Rule for Instant Outcome Transaction Issue';

    const sendPushNotificationRule = clonedCampaign.rules.find(
      rule => rule?.name === ruleNameToFind
    );

    clonedCampaign.pushNotificationRule = {
      name: ruleNameToFind,
      ruleId: sendPushNotificationRule?.id || null,
      send_notification: sendPushNotificationRule?.send_notification || false,
      outcome_options: {
        selected_media_type_id:
          sendPushNotificationRule?.outcome_options?.selected_media_type_id || null,
        custom_fields: sendPushNotificationRule?.outcome_options?.custom_fields || {}
      },
      event_params: {
        campaign_id: clonedCampaign.id
      }
    };

    // Extract send_notification_on_auto_redeem to root level (prefer campaign value over rule value)
    clonedCampaign.send_notification_on_auto_redeem =
      clonedCampaign.send_notification_on_auto_redeem ??
      sendPushNotificationRule?.send_notification_on_auto_redeem ??
      false;

    if (sendPushNotificationRule) {
      clonedCampaign.rules = clonedCampaign.rules.filter(rule => rule.name !== ruleNameToFind);
    }
  }

  if (clonedCampaign.campaign_type === 'stamp') {
    if (clonedCampaign.outcomes && clonedCampaign.outcomes.length > 0) {
      clonedCampaign.initialSlottedRewards = clonedCampaign.outcomes; // prepare for initial reward, it will get preprocessed inside campaign mechanic page
    }
  }

  if (clonedCampaign.campaign_type === 'game') {
    if (clonedCampaign.game_type === 'survey' || clonedCampaign.game_type === 'quiz') {
      clonedCampaign.campaign_type = clonedCampaign.game_type;
    }
  }

  if (clonedCampaign.campaign_type === 'streak') {
    clonedCampaign.temp = {
      interval_id: clonedCampaign.streak_intervals[0]?.id,
      streak_period: clonedCampaign.streak_intervals[0]?.streak_period,
      trigger_type: clonedCampaign.streak_campaign_mechanics?.streak_type,
      streak_unit: clonedCampaign.streak_intervals[0]?.streak_unit,
      event_count: clonedCampaign.streak_intervals[0]?.event_count,
      streak_mode: clonedCampaign.streak_campaign_mechanics?.streak_mode,
      target_spend: clonedCampaign.streak_intervals[0]?.target_spend
    };
    clonedCampaign.outcomes = clonedCampaign.streak_intervals[0]?.outcomes;
    clonedCampaign.milestones = clonedCampaign.streak_intervals;
  }

  return clonedCampaign;
};
